module.exports = __webpack_public_path__ + "static/logo-0c0a74bb8f3f62bf808a0a9f9ca56732.jpg";